module.exports = __webpack_public_path__ + "static/media/client-4.e6a92478.png";